// 新しく解放されたスキルの知らせ（レベルアップ時。結果画面・TOP・強化のスキル）。
// 「どの主Lvまで見たか」を端末に覚えておき、それより後に解放されたものを「新しい」とする。
import { CHARS, newlyUnlocked, type CharId, type SkillNode } from '@hyakki/core';
import { esc } from './dom';

const KEY = 'hk.skillSeenLv';

export function seenLevel(current: number): number {
  try {
    const v = Number(localStorage.getItem(KEY));
    if (Number.isFinite(v) && v > 0) return Math.min(v, current);
    localStorage.setItem(KEY, String(current)); // 初回は今のLvまで見たことにする（昔の解放を一度に出さない）
  } catch {
    /* 保存できない端末では毎回なし */
  }
  return current;
}

export function markSkillsSeen(level: number) {
  try {
    if (Number(localStorage.getItem(KEY) ?? 0) < level) localStorage.setItem(KEY, String(level));
  } catch {
    /* noop */
  }
}

/** まだ見ていない解放（共通＋4人の専用） */
export const unseenUnlocks = (level: number): SkillNode[] => newlyUnlocked(seenLevel(level), level);

/** 「共通：剛力・弐／アカリ：灯心」のような短い一覧 */
export function unlockListHtml(list: SkillNode[], max = 6): string {
  const groups = new Map<string, string[]>();
  for (const s of list) {
    const k = s.charId ? CHARS[s.charId as CharId].name : '共通';
    (groups.get(k) ?? groups.set(k, []).get(k)!).push(s.name);
  }
  let n = 0;
  const parts: string[] = [];
  for (const [k, names] of groups) {
    if (n >= max) break;
    const take = names.slice(0, Math.max(1, max - n));
    n += take.length;
    parts.push(`<span class="su-g"><em>${esc(k)}</em>${take.map(esc).join('・')}${names.length > take.length ? ' ほか' : ''}</span>`);
  }
  const rest = list.length - n;
  return parts.join('') + (rest > 0 ? `<span class="su-more">ほか${rest}</span>` : '');
}
